import { QueryClient } from '@tanstack/react-query'

export const createConsoleQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 300_000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          const status =
            typeof error === 'object' && error !== null && 'status' in error
              ? Number(error.status)
              : 0

          return failureCount < 1 && (status === 0 || status >= 500)
        },
      },
      mutations: {
        retry: false,
      },
    },
  })
